import { defineStore, storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import type { AppConfigDefinition, LanguageCodes } from '@/types'
import { useAppConfig } from '@/composables/useAppConfig';

const appStateStore = defineStore('appState', () => {
	const currentRoute = useRoute()
	const router = useRouter()
	const AppConfig = useAppConfig()
	
	const currentLng = computed<LanguageCodes>({
		get: () => (currentRoute.query.lng as LanguageCodes) ?? AppConfig.defaultLng ?? 'en',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, lng: value },
			})
		},
	})

	const currentAuthoringFilter = computed({
		get: () => (currentRoute.query.authoringStatus as string) ?? AppConfig.authoringStatus ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, authoringStatus: value },
			})
		},
	})

	const currentPublishingFilter = computed({
		get: () => (currentRoute.query.publishingStatus as string) ?? AppConfig.publishingStatus ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, publishingStatus: value },
			})
		},
	})

	const currentMedicalFilter = computed({
		get: () => (currentRoute.query.medicalSpeciality as string) ?? AppConfig.medicalSpeciality ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, medicalSpeciality: value },
			})
		},
	})

	const currentStudyType = computed({
		get: () => (currentRoute.query.studyMode as string) ?? AppConfig.studyType ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, studyType: value },
			})
		},
	})



	const currentoutcomeType = computed({
		get: () => (currentRoute.query.outcomeType as string) ?? AppConfig.outcomeType ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, outcomeType: value },
			})
		},
	})

	const currentContentClassification = computed({
		get: () => (currentRoute.query.contentClassification as string) ?? AppConfig.contentClassification ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, contentClassification: value },
			})
		},
	})

	const currenttargetAudience = computed({
		get: () => (currentRoute.query.targetAudience as string) ?? AppConfig.targetAudience ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, targetAudience: value },
			})
		},
	})

	const currentaplicationDomain = computed({
		get: () => (currentRoute.query.aplicationDomain as string) ?? AppConfig.aplicationDomain ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, aplicationDomain: value },
			})
		},
	})

	const currentDataFilter = computed({
		get: () => (currentRoute.query['dashboard-filter'] as string) ?? AppConfig.dashboardFilter ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, 'dashboard-filter': value },
			});
		},
	});
	const currentstudyMode = computed({
		get: () => (currentRoute.query['flag-mode'] as string) ?? AppConfig.studyMode ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, 'flag-mode': value },
			});
		},
	});

	const currentLatestDays = computed({
		get: () => (currentRoute.query['latest-days'] as string) ?? AppConfig.latestDays ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, 'latest-days': value },
			});
		},
	});
	const currentTestyourself = computed({
		get: () => (currentRoute.query['testYourself'] as string) ?? AppConfig.testYourself ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, 'testYourself': value },
			});
		},
	});
	const currentCollectionMode = computed({
		get: () => (currentRoute.query['collection-mode'] as string) ?? AppConfig.collectionMode ?? 'audience',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, 'collection-mode': value },
			});
		},
	});
	const currentPAGE_REQ_ID = computed({
		get: () => (currentRoute.query['PAGE_REQ_ID'] as string) ?? AppConfig.PAGE_REQ_ID ?? '',
		set: (value: string) => {
			router.push({
				path: currentRoute.path,
				query: { ...currentRoute.query, 'PAGE_REQ_ID': value },
			});
		},
	});

	return {
		currentLng,
		currentPublishingFilter,
		currentAuthoringFilter,
		currentMedicalFilter,
		currentStudyType,
		currentstudyMode,
		currentoutcomeType,
		currentContentClassification,
		currenttargetAudience,
		currentaplicationDomain,
		currentDataFilter,
		currentLatestDays,
		currentTestyourself,
		currentCollectionMode,
		currentPAGE_REQ_ID
	}
})

export const useAppStore = () => {
	const store = appStateStore()
	const refs = storeToRefs(store)

	return { ...store, ...refs }
}
